// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'babel-polyfill'
import router from './router'
import './assets/css/reset.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'lib-flexible/flexible';//在入口文件引入然后运行
 import wx from 'weixin-js-sdk';
import $ from 'jquery'
import store from './store'
import ECharts from 'vue-echarts'
import Blob from './Excel/Blob'
import Export2Excel from './Excel/Export2Excel.js'
import 'echarts'

Vue.config.productionTip = false;
Vue.use(ElementUI);

/* eslint-disable no-new */
const defVue = new Vue({
  el: '#app',
  router,
  store,
  components: {
  		App,
  },
  template: '<App/>',

})
export default defVue; 


// WEBPACK FOOTER //
// ./src/main.js